import { useEffect, useState } from 'react';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const useDrivers = (race, session) => {
  const [state, setState] = useState({ status: 'idle', drivers: [] });

  useEffect(() => {
    if (!race || !session) {
      setState({ status: 'idle', drivers: [] });
      return;
    }
    let cancelled = false;
    setState({ status: 'loading', drivers: [] });
    (async () => {
      try {
        const res = await fetch(
          `${API_BASE}/api/drivers?race=${encodeURIComponent(race)}&session=${encodeURIComponent(session)}`,
        );
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const body = await res.json();
        if (cancelled) return;
        setState({ status: 'ready', drivers: body.drivers || [] });
      } catch (err) {
        console.error('Failed to load drivers:', err);
        if (!cancelled) setState({ status: 'error', drivers: [] });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [race, session]);

  return state;
};
